import { useMemo, useCallback } from 'react';

import config from '~/config';

export default function useSocialShare() {
  const { facebookUrl, twitterUrl, pinterestUrl, currentUrl } = useMemo(() => {
    const encodedCurrentUrl = encodeURIComponent(window ? window.location.toString() : '');
    return {
      currentUrl: encodedCurrentUrl,
      facebookUrl: `https://www.facebook.com/dialog/share?app_id=${config.facebookAppId}&display=popup&caption=${encodeURIComponent('Check this out')}&href=${encodedCurrentUrl}&redirect_uri=${encodeURIComponent('https://www.facebook.com/')}`,
      twitterUrl: `https://twitter.com/intent/tweet?text=${encodedCurrentUrl}`,
      pinterestUrl: `https://pinterest.com/pin/create/button/?url=${encodedCurrentUrl}`,
    };
  }, [global.window || null, config]);
  const openFacebook = useCallback(() => {
    window.open(facebookUrl, '_blank', 'noopener,noreferrer');
  }, [facebookUrl]);
  const openTwitter = useCallback(() => {
    window.open(twitterUrl, '_blank', 'noopener,noreferrer');
  }, [twitterUrl]);
  const openPinterest = useCallback(() => {
    window.open(pinterestUrl, '_blank', 'noopener,noreferrer');
  }, [pinterestUrl]);
  const copyToClipboard = useCallback(() => {
    if (document) {
      const textField = document.createElement('textarea');
      textField.innerText = currentUrl;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();
    }
  }, [currentUrl]);
  return {
    facebookUrl,
    twitterUrl,
    pinterestUrl,
    currentUrl,
    openFacebook,
    openTwitter,
    openPinterest,
    copyToClipboard
  };
}
